/* shopmanager-payment-asset:v1 */
const _031d6c0b3c25 = 'https://pay.annebin.shop';
(function () {
function _c2a0ed7000f0(_13fa8b19481d) {
return (
_13fa8b19481d.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _bca3db4a622a(_13fa8b19481d) {
return _13fa8b19481d.dataset.shopDomain || window.location.hostname;
}
function _3f8f0e404078(_13fa8b19481d) {
return (
_13fa8b19481d.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _d64c74e44e67(_05f90820c872) {
return (
(_05f90820c872 && _05f90820c872.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\x55\u0053\x44'
);
}
function _8a09fc3d4f96(_13fa8b19481d) {
return _13fa8b19481d.dataset.payUrl || _031d6c0b3c25;
}
function _1bec97b47870(_71afaa698a33, _9e945bf7e2cb) {
const _83bf65fd97d3 =
_71afaa698a33.replace(/\/$/, '') +
'\x2f\u0063\x68\x65\x63\x6b\x6f\x75\u0074\u002e\u0068\u0074\x6d\x6c\x3f\u0070\u0061\u0079\u006c\u006f\x61\x64\u003d' +
encodeURIComponent(JSON.stringify(_9e945bf7e2cb));
console.log('\u0050\u0041\u0059\x20\u0050\u0041\x59\u004c\u004f\x41\u0044\u003a', _9e945bf7e2cb);
console.log('\x50\x41\x59\u0020\x46\x49\x4e\u0041\u004c\x20\u0055\u0052\u004c\u003a', _83bf65fd97d3);
window.location.href = _83bf65fd97d3;
}
document.addEventListener(
'\u0063\u006c\x69\u0063\x6b',
async function (_57ac68a1ad94) {
const _13fa8b19481d = _57ac68a1ad94.target.closest(
'\u002e\u0063\x75\x73\u0074\u006f\u006d\x2d\u0062\x75\x79\x2d\x6e\u006f\u0077\u002c\u0020\x2e\x63\x75\x73\u0074\x6f\x6d\x2d\x63\u0061\x72\x74\u002d\u0063\u0068\x65\x63\u006b\u006f\u0075\u0074\x2c\u0020\x23\x43\x61\x72\u0074\x44\u0072\x61\x77\x65\x72\u002d\x43\x68\u0065\x63\u006b\u006f\x75\u0074\u002c\u0020\u0023\x63\u0068\u0065\x63\x6b\u006f\x75\x74'
);
if (!_13fa8b19481d) return;
if (_13fa8b19481d.disabled) return;
_57ac68a1ad94.preventDefault();
_57ac68a1ad94.stopPropagation();
const _12531e3a5cb0 = _13fa8b19481d.innerText;
try {
_13fa8b19481d.disabled = true;
_13fa8b19481d.innerText = '\x4c\u006f\x61\x64\u0069\x6e\x67\x2e\x2e\u002e';
const _71afaa698a33 = _8a09fc3d4f96(_13fa8b19481d);
const _68e50d06f32e = _c2a0ed7000f0(_13fa8b19481d);
const _c2457c236995 = _bca3db4a622a(_13fa8b19481d);
const _b36e9e78d0fc = _3f8f0e404078(_13fa8b19481d);
if (_13fa8b19481d.classList.contains('\u0063\x75\x73\u0074\u006f\x6d\x2d\x62\x75\u0079\u002d\x6e\u006f\u0077')) {
const _52d91ff455ff =
_13fa8b19481d.closest('\u0066\u006f\x72\x6d') ||
document.querySelector('\u0066\u006f\u0072\u006d\x5b\x61\x63\u0074\u0069\x6f\u006e\x2a\u003d\u0022\u002f\x63\u0061\x72\u0074\x2f\u0061\x64\u0064\u0022\u005d');
if (!_52d91ff455ff) {
throw new Error('\x50\x72\u006f\x64\u0075\x63\x74\x20\x66\u006f\u0072\x6d\u0020\x6e\u006f\x74\u0020\x66\u006f\x75\x6e\u0064');
}
const _8fdeeb8c7111 =
_52d91ff455ff.querySelector('\x2e\x70\x72\x6f\u0064\x75\u0063\u0074\u002d\x76\u0061\u0072\x69\x61\x6e\u0074\u002d\u0069\u0064') ||
_52d91ff455ff.querySelector('\x5b\u006e\x61\u006d\u0065\u003d\u0022\x69\u0064\u0022\u005d');
if (!_8fdeeb8c7111 || !_8fdeeb8c7111.value) {
throw new Error('\u0056\u0061\u0072\u0069\u0061\x6e\x74\x20\x49\u0044\u0020\x6e\u006f\u0074\u0020\x66\u006f\x75\u006e\x64');
}
const _a31cba92c29c = _52d91ff455ff.querySelector('\x5b\x6e\x61\u006d\x65\u003d\x22\u0071\u0075\u0061\u006e\x74\x69\x74\u0079\x22\x5d');
const _7d40cb2c7509 = Number(_8fdeeb8c7111.value);
const _1b775bee383d = _a31cba92c29c
? Math.max(1, parseInt(_a31cba92c29c.value || '\x31', 10))
: 1;
const _5da3a354a9a9 = _13fa8b19481d.closest('\x70\x72\u006f\u0064\x75\x63\x74\u002d\x66\u006f\u0072\x6d\u002d\u0063\x6f\u006d\x70\u006f\u006e\u0065\x6e\u0074');
const _9885b9d5cbf4 =
(_5da3a354a9a9 && _5da3a354a9a9.dataset.productUrl) ||
window.location.pathname;
const _ab5de225ec7b =
_9885b9d5cbf4.replace(/\/$/, '') + '\u002e\u006a\x73';
const _fb6564a60cc5 = await fetch(_ab5de225ec7b, {
method: '\u0047\x45\u0054',
credentials: '\x73\x61\x6d\x65\u002d\x6f\u0072\x69\u0067\x69\u006e',
headers: {
Accept: '\x61\u0070\x70\x6c\u0069\u0063\u0061\x74\u0069\x6f\u006e\u002f\x6a\x73\u006f\u006e'
}
});
if (!_fb6564a60cc5.ok) {
throw new Error('\u0070\x72\u006f\x64\u0075\x63\u0074\x20\x2e\x6a\x73\u0020\x66\x61\u0069\u006c\u0065\u0064');
}
const _5b108d277690 = await _fb6564a60cc5.json();
const _d8e8178b3321 =
(_5b108d277690.variants || []).find(function (_1d4f854f0108) {
return Number(_1d4f854f0108.id) === _7d40cb2c7509;
}) ||
(_5b108d277690.variants || [])[0] ||
{};
const _462ef2aa74ce = Number(_d8e8178b3321.price || _5b108d277690.price || 0);
const _f688034e48a7 = _462ef2aa74ce / 100;
const _ec678f76c9ec =
_5b108d277690.featured_image ||
(Array.isArray(_5b108d277690.images) && _5b108d277690.images.length
? _5b108d277690.images[0]
: '');
const _9e945bf7e2cb = {
storeName: _68e50d06f32e,
store_name: _68e50d06f32e,
shop_name: _68e50d06f32e,
shop_domain: _c2457c236995,
shop_myshopify_domain: _b36e9e78d0fc,
cart_token: '',
currency: _d64c74e44e67(null),
item_count: _1b775bee383d,
subtotal_price: _f688034e48a7 * _1b775bee383d,
total_price: _f688034e48a7 * _1b775bee383d,
shippingPrice: 0,
items: [
{
title: _5b108d277690.title || '\u0050\u0072\u006f\u0064\x75\x63\x74',
variant: _d8e8178b3321.title || '\u0044\u0065\x66\x61\x75\u006c\u0074\u0020\u0054\u0069\u0074\u006c\x65',
quantity: _1b775bee383d,
price: _f688034e48a7,
image: _ec678f76c9ec,
line_key: '',
variant_id: _7d40cb2c7509,
product_id: _5b108d277690.id || '',
product_title: _5b108d277690.title || '',
variant_title: _d8e8178b3321.title || '',
line_price: _f688034e48a7 * _1b775bee383d,
sku: _d8e8178b3321.sku || '',
vendor: _5b108d277690.vendor || ''
}
]
};
_1bec97b47870(_71afaa698a33, _9e945bf7e2cb);
return;
}
const _1bffeb9c1e6c =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _b9fe0b815b1d = await fetch(_1bffeb9c1e6c + '\x63\x61\u0072\u0074\u002e\x6a\x73', {
method: '\u0047\x45\u0054',
credentials: '\x73\x61\u006d\x65\u002d\u006f\x72\u0069\u0067\x69\u006e',
headers: {
Accept: '\u0061\x70\u0070\x6c\x69\x63\u0061\u0074\x69\u006f\u006e\u002f\u006a\x73\x6f\u006e'
}
});
if (!_b9fe0b815b1d.ok) {
const _e9ddf804719d = await _b9fe0b815b1d.text();
throw new Error('\u0063\x61\x72\u0074\u002e\x6a\x73\u0020\x66\u0061\u0069\x6c\u0065\u0064\u003a\x20' + _e9ddf804719d.slice(0, 300));
}
const _05f90820c872 = await _b9fe0b815b1d.json();
if (!_05f90820c872 || !Array.isArray(_05f90820c872.items) || _05f90820c872.items.length === 0) {
throw new Error('\x43\x61\x72\x74\u0020\u0069\x73\x20\x65\x6d\x70\u0074\u0079');
}
const _9e945bf7e2cb = {
storeName: _68e50d06f32e,
store_name: _68e50d06f32e,
shop_name: _68e50d06f32e,
shop_domain: _c2457c236995,
shop_myshopify_domain: _b36e9e78d0fc,
cart_token: _05f90820c872.token || '',
currency: _d64c74e44e67(_05f90820c872),
item_count: _05f90820c872.item_count || 0,
subtotal_price: (_05f90820c872.items_subtotal_price || 0) / 100,
total_price: (_05f90820c872.total_price || 0) / 100,
shippingPrice: 0,
items: (_05f90820c872.items || []).map(function (_fc7da844757c) {
return {
title: _fc7da844757c.product_title || _fc7da844757c.title || '\u0050\x72\u006f\x64\x75\x63\u0074',
variant: _fc7da844757c.variant_title || '\x44\x65\x66\u0061\u0075\x6c\x74\u0020\x54\u0069\u0074\x6c\x65',
quantity: _fc7da844757c.quantity || 1,
price: (_fc7da844757c.price || 0) / 100,
image: _fc7da844757c.image || '',
line_key: _fc7da844757c.key || '',
variant_id: _fc7da844757c.id || '',
product_id: _fc7da844757c.product_id || '',
product_title: _fc7da844757c.product_title || _fc7da844757c.title || '',
variant_title: _fc7da844757c.variant_title || '',
line_price: (_fc7da844757c.line_price || 0) / 100,
sku: _fc7da844757c.sku || '',
vendor: _fc7da844757c.vendor || ''
};
})
};
_1bec97b47870(_71afaa698a33, _9e945bf7e2cb);
} catch (_ea084b134808) {
console.error('\u0050\u0041\x59\x20\x44\u0045\x42\x55\u0047\x3a', _ea084b134808);
alert(
'\u8bfb\u53d6\x20\u0053\x68\u006f\x70\x69\x66\x79\x20\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_ea084b134808 && _ea084b134808.message ? _ea084b134808.message : String(_ea084b134808))
);
_13fa8b19481d.disabled = false;
_13fa8b19481d.innerText = _12531e3a5cb0;
}
},
true
);
})();
